<!-- 地方平台详情页 -->
<template>
  <div class="local-detail">
    <div
      class="banner"
      :style="{
        'background-image': bannerData.bannerUrl
          ? `url(${bannerData.bannerUrl})`
          : `url(${defaultBannerImage})`,
      }"
    >
      <div class="banner-content">
        <h1>{{ areaName }} 一站式算力交易和服务平台</h1>
        <p>
          实现对通用算力、超算算力、人工智能算力的统一管理、统一服务和统一运营
        </p>
        <div
          class="banner-more"
          @click="handleToBannerMore"
          v-if="bannerData.linkUrl"
        >
          了解更多
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 顶部服务卡片区域 -->
      <div class="top-section">
        <div class="section-title">一网调度长三角，数智赋能新江苏</div>
        <div class="service-cards">
          <div class="service-card">
            <img
              src="../../assets/jiangsu/全省统一算力交易服务生态市场.png"
              alt="全省统一算力交易服务生态市场"
            />
            <div class="card-content">
              <h3>全省统一算力交易服务生态市场</h3>
              <p>
                搭建全省统一算力生态市场，实现算力需求与供给的高效匹配，提供"模数算按"一体化服务
              </p>
            </div>
          </div>
          <div class="service-card">
            <img
              src="../../assets/jiangsu/省级算力政策服务权威主渠道.png"
              alt="省级算力政策服务权威主渠道"
            />
            <div class="card-content">
              <h3>省级算力政策服务权威主渠道</h3>
              <p>
                统筹全省算力政策，提供线上化、全流程可信存证的兑现审
                批能力，基于可信算力时长数据赋能支撑政府决策。
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 功能模块展示区域 -->
      <div class="function-section">
        <div class="section-title">打造"模、数、算、安"一体化服务能力</div>
        <div class="function-cards">
          <div
            class="function-card"
            v-for="(card, index) in functionCards"
            :key="index"
          >
            <img :src="card.imgSrc" :alt="card.title" />
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
        </div>
      </div>

      <!-- 新闻动态和政策指南区域 -->
      <div class="news-section">
        <div class="tab-header">
          <div
            class="tab-item"
            :class="{ active: activeTab === 'news' }"
            @click="activeTab = 'news'"
          >
            新闻动态
          </div>
          <div
            class="tab-item"
            :class="{ active: activeTab === 'policy' }"
            @click="activeTab = 'policy'"
          >
            政策指南
          </div>
        </div>
        <div class="news-cards" v-if="activeTab === 'news'">
          <div
            class="news-card"
            v-for="(item, index) in newsList"
            :key="index"
            @click="handleNewsDetail(item)"
          >
            <img class="news-img" :src="item.photoUrl" alt="" />
            <div class="news-infos">
              <h3>{{ item.title }}</h3>
              <p>
                {{ item.info.replace(/<[^>]+>/g, "").slice(0, 100) }}
              </p>
              <div class="news-date">{{ item.createTime }}</div>
            </div>
          </div>
        </div>
        <div class="policy-cards" v-if="activeTab === 'policy'">
          <div
            class="policy-card"
            v-for="(item, index) in policyList"
            :key="index"
          >
            <div class="policy-left">
              <h3>{{ item.title }}</h3>
              <p>
                {{ item.info }}
              </p>
            </div>
            <div class="policy-btn" @click="handlePolicyDetail(item)">
              查看详情
            </div>
          </div>
        </div>
      </div>

      <!-- 联系方式区域 -->
      <div class="contact-section">
        <div class="section-title">联系方式</div>
        <div class="contact-content">
          <div class="map-container">
            <img
              src="../../assets/jiangsu/ditu.png"
              alt="地图"
              class="map-image"
            />
          </div>
          <div class="contact-info">
            <h3>江苏省数据集团有限公司</h3>
            <p class="address">地址：{{ contactInfo.address }}</p>
            <p class="email">邮箱：{{ contactInfo.email }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { areaNewsList, areaPolicyList, areaPlatformList } from "@/api/admin.js";
export default {
  data() {
    return {
      areaType: "", // 区域类型
      areaName: "", // 区域名称
      activeTab: "news", // 当前激活的标签
      functionCards: [
        {
          title: "模型",
          imgSrc: require("../../assets/jiangsu/模.png"),
          description: "提供模型开发、训练、推理、部署全流程服务",
        },
        {
          title: "数据",
          imgSrc: require("../../assets/jiangsu/数.png"),
          description: "提供数据采集、处理、存储、应用全周期服务",
        },
        {
          title: "算力",
          imgSrc: require("../../assets/jiangsu/算.png"),
          description: "提供算力接入、监测、调度、计费全过程服务",
        },
        {
          title: "安全",
          imgSrc: require("../../assets/jiangsu/安.png"),
          description: "提供平台网络、系统、数据、应用全方位服务",
        },
        ],
      contactInfo: {
        address: "南京市建邺区江东中路373号金融城8号楼18层",
        phone: "025-89xxx234",
        email: "jsdata@jsdata.com",
      },
      areaOptions: [
        {
          value: 1,
          label: "江苏",
        },
        {
          value: 2,
          label: "上海",
        },
        {
          value: 3,
          label: "安徽",
        },
        {
          value: 4,
          label: "浙江",
        },
      ],
      newsList: [],
      policyList: [],
      bannerData: {
        bannerUrl: "",
        linkUrl: "",
      },
      defaultBannerImage: require("../../assets/jiangsu/jiangsubanner.png"), // 默认图片路径
    };
  },
  watch: {
    activeTab(newVal, oldVal) {
      if (newVal === "news") {
        this.getNewsList();
      } else if (newVal === "policy") {
        this.getPolicyList();
      }
    },
  },
  mounted() {
    // 在这里执行页面加载后的操作
  },
  created() {
    this.areaType = this.$route.query.areaType;
    this.areaName =
      this.areaOptions.find((item) => item.value == this.areaType)?.label ||
      this.areaType;
    this.getNewsList();
    this.getBannerList();
  },
  methods: {
    // 获取banner列表
    async getBannerList() {
      try {
        let params = {
          areaType: this.areaType,
        };
        const res = await areaPlatformList(params);
        if (res.code === 200) {
          if (res.data.records.length > 0) {
            this.bannerData = res.data.records[0];
          } else {
            this.bannerData = {
              bannerUrl: "",
              linkUrl: "",
            };
          }
        }
      } catch (error) {
        console.error("获取banner列表失败:", error);
      }
    },
    // 获取新闻列表
    getNewsList() {
      areaNewsList({
        areaType: this.areaType,
        current: 1,
        size: 3,
      }).then((res) => {
        this.newsList = res.data.records;
      });
    },
    // 获取政策列表
    getPolicyList() {
      areaPolicyList({
        areaType: this.areaType,
        current: 1,
        size: 3,
      }).then((res) => {
        this.policyList = res.data.records;
      });
    },
    // 跳转至政策详情页
    handlePolicyDetail(item) {
      if (!item.linkUrl) return;
      window.open(item.linkUrl, "_blank");
    },
    // 跳转至新闻详情页
    handleNewsDetail(item) {
      this.$router.push({
        path: `/jsnews/detail/${item.id}`,
      });
    },
    // 跳转至更多详情
    handleToBannerMore() {
      window.open(this.bannerData.linkUrl, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.local-detail {
  .section-title {
    text-align: center;
    font-size: 26px;
    color: #333333;
    margin: 40px 0;
  }

  .section-title-en {
    text-align: center;
    font-size: 16px;
    color: #cdcdcd;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .banner {
    height: 220px;
    color: white;
    display: flex;
    align-items: center;
    background-image: url("../../assets/jiangsu/jiangsubanner.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .banner-content {
      padding: 0 241px;
      position: relative;
      width: 100%;

      .banner-more {
        position: absolute;
        right: 241px;
        top: 50%;
        transform: translateY(-50%);
        color: #fff;
        cursor: pointer;
        font-size: 14px;
        width: 140px;
        height: 50px;
        border-radius: 25px 25px 25px 25px;
        border: 2px solid #e3e3e3;
        text-align: center;
        line-height: 50px;
      }
      h1 {
        font-size: 48px;
        margin-bottom: 16px;
      }

      p {
        font-size: 16px;
        opacity: 0.9;
        margin-bottom: 60px;
      }
    }
  }

  .container {
    margin: 0 auto;
    padding: 0;
    background-color: #f7f8fa;
  }

  .top-section {
    padding: 40px 241px 67px;
    background-color: #fff;

    .service-cards {
      display: flex;
      gap: 20px;
      margin-top: 30px;
    }

    .service-card {
      display: flex;
      align-items: center;
      width: calc(50% - 10px);
      height: 349px;
      padding: 30px 38px;
      background-color: #ffffff;
      box-sizing: border-box;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #e3e3e3;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      }

      img {
        width: 193px;
        height: 196px;
        margin-right: 30px;
        object-fit: contain;
      }

      .card-content {
        flex: 1;

        h3 {
          font-size: 20px;
          color: #333333;
          margin-bottom: 16px;
        }

        p {
          font-size: 14px;
          color: #858585;
          line-height: 24px;
        }
      }
    }
  }

  .function-section {
    padding: 40px 241px 67px;
    background-image: url("../../assets/bg/diqvzhuyebanner2.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .function-cards {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
      margin-top: 30px;
    }

    .function-card {
      background-color: #fff;
      padding: 30px;
      border-radius: 2px;
      text-align: center;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      }

      img {
        width: 133px;
        height: 151px;
        object-fit: contain;
      }

      h3 {
        font-size: 24px;
        color: #333333;
        margin-bottom: 12px;
        margin-top: 0;
        font-weight: normal;
      }

      p {
        font-size: 14px;
        color: #858585;
        line-height: 22px;
      }
    }
  }

  .news-section {
    padding: 67px 241px;
    background-image: url("../../assets/bg/shan.png");
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;

    .tab-header {
      display: flex;
      justify-content: center;
      gap: 40px;
      margin-bottom: 40px;

      .tab-item {
        font-size: 26px;
        color: #999999;
        cursor: pointer;
        position: relative;
        padding-bottom: 8px;

        &.active {
          color: #333333;
          font-weight: 500;

          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 40px;
            height: 4px;
            background-color: #2b5bdc;
            border-radius: 2px;
          }
        }
      }
    }

    .news-cards {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      margin-top: 30px;
    }

    .news-card {
      background-color: #fff;
      border: 1px solid #e3e3e3;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      }

      .news-img {
        height: 242px;
        width: 100%;
      }

      .news-infos {
        padding: 0 24px 24px 24px;
      }

      h3 {
        font-size: 18px;
        color: #333333;
        margin-bottom: 12px;
        font-weight: normal;
      }

      p {
        font-size: 14px;
        color: #858585;
        line-height: 24px;
        margin-bottom: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .news-date {
        font-size: 14px;
        color: #999999;
      }
    }

    .policy-card {
      background-color: #fff;
      padding: 34px 24px;
      border-radius: 8px;
      border: 1px solid #e3e3e3;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      &:hover {
        /* transform: translateY(-5px); */
        /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15); */
      }

      .policy-left {
        flex: 1;
        border-left: 4px solid #057bf3;
        padding-left: 20px;
      }
      .policy-btn {
        width: 118px;
        height: 40px;
        background: #067bf3;
        color: white;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;

        &:hover {
          /* background-color: #1e4bc6; */
        }
      }

      h3 {
        font-size: 20px;
        color: #333333;
        margin-bottom: 12px;
        font-weight: 500;
        margin-top: 0;
      }

      p {
        font-size: 14px;
        color: #858585;
        line-height: 24px;
        margin-bottom: 0px;
      }

      .policy-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .policy-date {
          font-size: 14px;
          color: #999999;
        }

        .policy-btn {
          padding: 6px 12px;
          background-color: #2b5bdc;
          color: white;
          border-radius: 4px;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            background-color: #1e4bc6;
          }
        }
      }
    }
  }

  .contact-section {
    padding: 40px 241px;
    background-color: #fff;

    .contact-content {
      display: flex;
      margin-top: 30px;
    }

    .map-container {
      height: 544px;
      border-radius: 8px;
      overflow: hidden;

      .map-image {
        /* width: 100%; */
        height: 100%;
        object-fit: cover;
      }
    }

    .contact-info {
      padding: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      h3 {
        font-size: 26px;
        color: #333333;
        margin-bottom: 16px;
        font-weight: 500;
      }

      p {
        font-size: 18px;
        color: #858585;
        margin: 2px 0;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
